import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { formPreviewOf } from './form/formPreview';
import { previewSpan } from './form/previewSpan';
import type { IFormPreviewProps } from './IFormPreviewProps';
import { useGroupName } from './form/useGroupName';

/**
 * «Перегляд» форми (прототип v4 fpKey / fpTabs / fpGroups): смуга назви, пігулки ключового рядка (Статус · Пріоритет · Термін), вкладки
 * («Загальне» — активна), поле назви, теги й опис під заголовком (якщо увімкнені), групи — поля в сітці на чотири колонки за шириною S/M/L.
 */
export function FormPreview({ rt, editor }: IFormPreviewProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const groupName = useGroupName(rt.key);
  const view = formPreviewOf(rt, editor.form, editor.published);
  const label = (key: string) => strings.field(rt.key, key, rt.fields.find((f) => f.key === key)?.label);
  return (
    <aside className="st-fp" aria-label={t('modSettings.form.previewLabel')}>
      <div className="st-fp__label">{t('modSettings.form.preview')}</div>
      <div className="st-fp__card">
        <div className="st-fp__title" />
        <div className="st-fp__keys">{view.keys.map((k) => <span key={k}>{t(`modSettings.form.keyPill.${k}`)}</span>)}</div>
        <div className="st-fp__tabs">{view.tabs.map((tab, i) => <span key={tab} className={i === 0 ? 'is-on' : undefined}>{t(`recordPage.tabs.${tab}`)}</span>)}</div>
        <div className="st-fp__input">{t('modSettings.form.titlePh')}</div>
        {view.tags && <div className="st-fp__tags"><span /><span /></div>}
        {view.description && <div className="st-fp__area">{t('modSettings.form.descPh')}</div>}
        {view.groups.map((g) => (
          <div key={g.id} className="st-fp__group">
            <span className="st-fp__gname">{groupName(g)}</span>
            <div className="st-fp__grid">
              {g.fields.map((x) => {
                const name = label(x.key);
                return <span key={x.key} title={`${name} · ${x.width}`} style={{ gridColumn: previewSpan(x.width) }}><span>{name}</span><span className="st-fp__w">{x.width}</span></span>;
              })}
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}
